<template>
  <Wrapper @openEditor="$emit('openEditor')">
    <div class="job-list-container">
      <div class="title" :class="!title && 'no-wrapper'">
        <div class="title-text module-text-title" ref="titleEl">{{ title }}</div>
        <div class="under-line" :style="titleUnderLineStyle">
          <el-divider v-if="hasTitleUnderLine"></el-divider>
        </div>
      </div>
      <div class="keyword-search-wrapper">
        <el-input :placeholder="$t('microSite.jobList.jobSearchKeywordPlaceholder')" class="keyword-input" v-model="keyword">
          <el-button slot="append" type="primary" class="search-btn custom-btn" @click="handleSeachBtnClick">
            {{ $t('microSite.jobList.jobSearchBtn') }}
          </el-button>
        </el-input>
      </div>
      <div class="job-list">
        <template v-for="(job, index) in showJobs" >
          <MobileStyle
            v-if="isMobile"
            :key="index"
            :job="job"
            @click.native="openJobDetailPage(job)"
          />
          <PcStyle
            v-else
            :key="index"
            :job="job"
            @click.native="openJobDetailPage(job)"
          />
        </template>
      </div>
        <div class="show-more-jobs" @click="showMoreJobs" v-if="hasMore && showBtn">
          <el-button class="custom-btn">{{ $t('microSite.jobList.showMoreJobs') }}</el-button>
        </div>
    </div>
  </Wrapper>
</template>

<script>
import _ from 'lodash'
import Wrapper from '../../../components/render/wrapper'
import { mapActions, mapGetters, mapState } from 'vuex'
import Optional from 'optional-js'
import PcStyle from './pcStyle'
import MobileStyle from './mobileStyle'
import { MICRO_SITE_TYPE } from '@/constant/common'
import { appendSourceCode } from '@/utils/common'

export default {
  components: {
    Wrapper, PcStyle, MobileStyle
  },
  props: {
    title: {
      type: String,
      default: ''
    },
    jobIds: {
      type: Array,
      default: null
    },
    rootCompanyId: {
      type: Number,
      default: null
    },
    underLine: {
      type: Object,
      required: false
    },
    styleConfig: {
      type: Object,
      required: false
    },
    companies: {
      required: false
    },
    checkedCompanyIds: {
      required: false
    },
    selectedJobIds: {
      required: false
    }
  },
  data () {
    return {
      jobs: null,
      keyword: '',
      showJobSize: 9,
      showBtn: true,
      hasMore: true,
      search: {
        keyword: null
      },
      showJobs: [],
      geolocation: {
        lng: null,
        lat: null
      }
    }
  },
  computed: {
    ...mapState('microSite', [
      'themes'
    ]),
    ...mapGetters('microSite', [
      'isMobile'
    ]),
    updatejobIds () {
      return this.jobIds
    },
    hasTitleUnderLine () {
      return this.underLine && this.underLine.title && this.underLine.title.isShow
    },
    titleUnderLineStyle () {
      return this.formatUnderLineStyle('title', this.underLine.title)
    },
    language () {
      return this.$i18n.locale
    },
    isQuestionnaireType () {
      const siteType = this.$route.params.type
      if (siteType && [MICRO_SITE_TYPE.satisfaction_survey, MICRO_SITE_TYPE.post_applicant].includes(siteType)) {
        return true
      }
      return this.$route.meta.isQuestionnaire || false
    }
  },
  created () {

  },
  mounted () {
    this.getGeolocation(() => {
      this.fetchJob(this.jobIds)
      this.setJobIds(this.jobIds)
    })
  },
  watch: {
    updatejobIds (val) {
      this.fetchJob(this.jobIds)
      this.setJobIds(this.jobIds)
    },
    language (val) {
      this.fetchJob(this.jobIds)
    }
  },
  methods: {
    ...mapActions('microSite', [
      'getJob',
      'setJobIds'
    ]),
    ...mapActions('referral', ['getJobReferralUrl']),
    getGeolocation (callback) {
      navigator.geolocation.getCurrentPosition(position => {
        this.geolocation.lng = position.coords.longitude
        this.geolocation.lat = position.coords.latitude
        callback()
      }, () => {
        callback()
      }, {
        enableHighAccuracy: true,
        maximumAge: 5000,
        timeout: 1000
      })
    },
    async fetchJob (jobIds) {
      this.jobs = Optional.ofNullable(await this.getJob({
        job_ids: jobIds,
        companies_ids: this.checkedCompanyIds,
        is_questionnaire_site: this.isQuestionnaireType,
        site_id: this.$route.params.siteId,
        lng: this.geolocation.lng,
        lat: this.geolocation.lat
      })).map(item => item).orElse({})
      this.searchJob()
    },
    searchJob () {
      let jobs = this.jobs
      let keyword = this.search.keyword || ''
      if (keyword && keyword.trim()) {
        keyword = keyword.trim().toLowerCase()
        jobs = _.filter(this.jobs, item => {
          return item.title.toLowerCase().includes(keyword)
        })
      }
      this.hasMore = jobs.length > this.showJobSize
      this.showJobs = jobs.slice(0, this.showJobSize)
    },
    async openJobDetailPage (job) {
      const listReferralId = this.$route.query.lReferId
      const needOpenNewPage = this.$route.name === 'microSiteAdmin'
      if (listReferralId) {
        const jobId = job.id
        const url = await this.getJobReferralUrl({ listReferralId, jobId })
        this.$router.push(appendSourceCode(url))
      } else {
        const url = appendSourceCode(job.url)
        if (needOpenNewPage) {
          window.open(url, '_blank')
        } else {
          window.location.href = url
        }
      }
    },
    handleSeachBtnClick () {
      this.search.keyword = this.keyword
      this.showJobSize = 9
      this.searchJob()
    },
    showMoreJobs () {
      this.showJobSize += 9
      this.searchJob()
      this.showMoreJobBtn = !this.showMoreJobBtn
      this.$nextTick(() => {
        this.showMoreJobBtn = !this.showMoreJobBtn
      })
    },
    formatUnderLineStyle (type, config, isSelfTigger) {
      let width = config.width
      let el = null
      if (this.$refs) {
        if (type === 'title') {
          el = this.$refs.titleEl
        }
      }
      if (el) {
        if (!width || width === 'full') {
          width = '100%'
        } else if (!isNaN(width)) {
          width = width + 'px'
        } else if (width === 'compute') {
          width = (el.clientWidth + 60) + 'px'
        }
        const underLineEl = el.nextElementSibling.firstElementChild
        if (underLineEl) {
          const style = underLineEl.style
          style.width = width
          style.backgroundColor = config.color || '#DCDFE6'
        }
      } else if (!isSelfTigger) {
        this.$nextTick(() => this.formatUnderLineStyle(type, config, true))
      }
      return { }
    }
  }
}
</script>

<style lang="scss" scoped>
.site-common {
  .job-list-container {
    text-align: center;

    .under-line {
      width: 100%;

      .el-divider {
        margin: 0 auto;
      }
    }

    .title {
      margin-bottom: 20px;

      .title-text {
        display: inline-block;
      }
    }

    .keyword-search-wrapper {
      overflow: hidden;

      .search-btn {
        border-radius: 0;
        border-color: transparent;
      }

      ::v-deep {
        .el-input__inner {
          border-top-left-radius: 0;
          border-bottom-left-radius: 0;
        }

        .el-input-group__append {
          border-radius: 0;
          border: unset;

          .el-button {
            padding: 14px 20px;
          }
        }
      }
    }

    .job-list {
      margin-top: 20px;
      text-align: left;
    }

    .show-more-jobs {
      margin-top: 50px;

      button {
        border-radius: 0;
        border: 0;
      }
    }
  }
}

.site-mobile {
  .job-list-container {
    padding: 20px 10px;

    .title {
      .under-line {
        margin-top: 10px;
      }
    }

    .keyword-search-wrapper {
      overflow: hidden;

      .keyword-input {
        width: 100%;
        text-align: center;

        .el-input-group__append {
          border-radius: 0;
          border: unset;

          .el-button {
            padding: 14px 20px;
          }
        }
      }
    }

    .job-list {
      margin-top: 0;
    }
  }
}

.site-pc {
  .job-list-container {
    width: 960px;
    margin: 0 auto;

    .title {
      .under-line {
        margin-top: 20px;
      }
    }
  }
}
</style>
